import { render, staticRenderFns } from "./organization-card.vue?vue&type=template&id=0066d8d7&scoped=true"
import script from "./organization-card.vue?vue&type=script&lang=js"
export * from "./organization-card.vue?vue&type=script&lang=js"
import style0 from "./organization-card.vue?vue&type=style&index=0&id=0066d8d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0066d8d7",
  null
  
)

export default component.exports